module.exports = "/_next/static/images/af09d0183d7c3906135b68e06e1ec38a-tiger.png.webp";